import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { MockComponent } from '@kutil/test';

const ANNOUNCEMENT_CLEAR_TIME = 500;
let timer: ReturnType<typeof setTimeout>;

@Component({
  selector: 'kui-a11y-live-announce',
  standalone: true,
  templateUrl: './a11y-live-announce.component.html',
})
export class A11yLiveAnnounceComponent implements OnChanges, OnDestroy {
  @Input() politenessSetting: 'polite' | 'assertive' | 'off' = 'polite';
  @Input() announcement = ''; // NOTE: Translate when passing value in!

  ngOnChanges(changes: SimpleChanges) {
    if (changes['announcement']) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        this.announcement = '';
      }, ANNOUNCEMENT_CLEAR_TIME);
    }
  }

  ngOnDestroy() {
    this.announcement = '';
  }
}

export const MockA11yLiveAnnounceComponent = MockComponent({
  selector: 'kui-a11y-live-announce',
  inputs: ['politenessSetting', 'announcement'],
});
